import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow--sprite",
  "use": "arrow--sprite-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol viewBox=\"0 0 20 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow--sprite\">\n<path d=\"M19.2071 8.70711C19.5976 8.31658 19.5976 7.68342 19.2071 7.29289L12.8431 0.928932C12.4526 0.538407 11.8195 0.538407 11.4289 0.928932C11.0384 1.31946 11.0384 1.95262 11.4289 2.34315L17.0858 8L11.4289 13.6569C11.0384 14.0474 11.0384 14.6805 11.4289 15.0711C11.8195 15.4616 12.4526 15.4616 12.8431 15.0711L19.2071 8.70711ZM-8.74228e-08 9L18.5 9L18.5 7L8.74228e-08 7L-8.74228e-08 9Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol